import PropTypes from "prop-types";
import React from 'react';
import {Translate, withLocalize} from "react-localize-redux";
import {Button, Form, FormFeedback, FormGroup, Input, Label} from "reactstrap";
import {Formik} from "formik";

import {isEmptyString} from "../../../../utils/string-utils";

const propTypes = {
  config: PropTypes.shape({
    device: PropTypes.shape({
      Identifier: PropTypes.string,
      Language: PropTypes.string
    }).isRequired,
  }).isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string.isRequired,
    code_long: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })),
  onSubmit: PropTypes.func.isRequired
};

const GeneralSettingsForm = (props) => {

  const { config, /*languages,*/ translate } = props;

  const handleSubmit = (values, { resetForm }) => {
    let data = { ...values };
    props.onSubmit(data);
    resetForm(values);
  };

  const handleValidation = (values) => {
    const errors = {};
    const regex = /^[a-zA-ZÀ-ú0-9\-_]*$/;

    //Identifier
    if(isEmptyString(values.identifier)){
      errors.identifier = 'genericLabel.REQUIRED_FIELD.text';
    }
    else if (values.identifier.length > 128) {
      errors.identifier = 'genericLabel.TOO_LONG.text';
    }
    else if (!regex.test(values.identifier)) {
      errors.identifier = 'genericLabel.INVALID_FORMAT.text';
    }

    return errors;
  };

  return (
    <Formik initialValues={{
              identifier: config.device.Identifier,
              language: config.device.Language,
              enableControlEnd2End: config.other.enableControlEnd2End
            }}
            validate={ handleValidation }
            validateOnBlur={false}
            validateOnChange={true}
            onSubmit={ handleSubmit }>
      {({
          values,
          errors,
          dirty,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          /* and other goodies */
        }) => (
        <Form onSubmit={ handleSubmit }>
          <section className="form-section">
            <FormGroup>
              <Label for="identifier">
                <Translate id="genericLabel.STREAMHUB_ID.text"/>
              </Label>
              <Input type="text"
                     name="identifier"
                     id="general_identifier"
                     invalid={errors.identifier !== undefined}
                     placeholder={ translate('genericLabel.STREAMHUB_ID.text') }
                     value={values.identifier}
                     onChange={handleChange}/>
              <FormFeedback>
                <Translate id={errors.identifier} />
              </FormFeedback>
            </FormGroup>
            <FormGroup check>
              <Label check>
                <Input type="checkbox"
                      name="enableControlEnd2End"
                      id="general_enableControlEnd2End"
                      onChange={handleChange}
                      checked={values.enableControlEnd2End}/>{' '}
                Enforce frame accurate end-to-end latency
              </Label>
              <div className="indicator">
              Enforce end-to-end latency compliance at frame level. In counterpart you may observe a delay of start time for your live outputs.
              </div>
              <div className="indicator">
              When not checked, the end-to-end latency is applied with some limited frame deviation
              </div>
            </FormGroup>
            {/*<FormGroup>*/}
              {/*<Label for="language">*/}
                {/*<Translate id="genericLabel.LANGUAGE.text"/>*/}
              {/*</Label>*/}
              {/*<Input type="select"*/}
                     {/*name="language"*/}
                     {/*id="language"*/}
                     {/*value={values.language}*/}
                     {/*onChange={handleChange}>*/}
                {/*{ languages && languages.map(language => (*/}
                  {/*<option key={language.code_long} value={language.code_long}>{ language.name }</option>*/}
                {/*))}*/}
              {/*</Input>*/}
            {/*</FormGroup>*/}
          </section>
          <FormGroup className="buttons">
            <Button id="general_saveButton"
                    color="primary"
                    disabled={isSubmitting || !dirty}
                    type="submit">
              <Translate id="genericLabel.SAVE.text"/>
            </Button>
          </FormGroup>
        </Form>
      )}
    </Formik>
  )
};

GeneralSettingsForm.propTypes = propTypes;

export default withLocalize(GeneralSettingsForm);